const stateroomsRules = {
  rooms: ["required", "integer", { min_number: 1 }, { max_number: 3 }],
};

export default stateroomsRules;
